import {gql} from "@apollo/client";

export const INCREMENT_EVENT_FIELDS = gql`
    mutation IncrementEvent($uuid: String!, $fields: [FieldsEnum!])  {
        incrementEvent(uuid: $uuid, fields: $fields)
    }
`;

export const DELETE_EVENT = gql`
    mutation DeleteEvent($uuid: String!) {
        deleteEvent(uuid: $uuid)
    }
`;
